import {
  getCspCategoryCodes,
  getCspCategoryLabels,
  getCspCodes,
  getCspCodesByCategory,
  getCspLabels,
} from 'src/services/ProfessionApiStore'
import type { Scalar } from 'src/tpbp-core/models/global.type'

export function getCspEnumsByCategory(category: string): Scalar[] {
  const cspsByCategory = getCspCodesByCategory()

  return cspsByCategory.get(category) ?? []
}
export function getCspEnums(category: string): Scalar[] {
  if (category) {
    return getCspEnumsByCategory(category)
  }
  const csps = getCspCodes()

  return csps
}

export function getCspLabel(csp) {
  const cspLabels = getCspLabels()

  return cspLabels[csp] || csp
}

export function getCspCategoryEnums(): string[] {
  const cspCategories = getCspCategoryCodes()

  return cspCategories
}

export function getCspCategoryLabel(csp) {
  const cspLabels = getCspCategoryLabels()

  return cspLabels[csp] || csp
}
